import styled from "styled-components";

export const WidthWrapper = styled.div<{ $width: number }>`
  width: min(${(props) => props.$width}px, 100%);

  @media (max-width: 1366px), (max-height: 900px) {
    width: min(${(props) => Math.max(props.$width - 60, 400)}px, 100%);
  }

  @media (max-width: 1024px), (max-height: 760px) {
    width: min(${(props) => Math.max(props.$width - 110, 340)}px, 100%);
  }
`;
